import { SelectItem } from "@/components/ui/select";
import type { DeviceWorkerItem } from "@/lib/api";
import {
	DeviceStatusDot,
	PlatformIcon,
	deviceName,
	deviceSecondaryLabel,
	deviceVersion,
	inferredPlatform,
} from "./device-display";
export function DeviceSelectItem({ device }: { device: DeviceWorkerItem }) {
	const version = deviceVersion(device.app_version);
	const secondary = deviceSecondaryLabel(device, version);
	return (
		<SelectItem value={device.id}>
			<span className="flex items-center gap-2">
				<DeviceStatusDot online={device.online} />
				<PlatformIcon platform={inferredPlatform(device)} />
				<span>{deviceName(device)}</span>
				{secondary ? (
					<span className="text-xs text-muted-foreground">· {secondary}</span>
				) : null}
				{device.online ? null : (
					<span className="text-xs text-muted-foreground">· offline</span>
				)}
			</span>
		</SelectItem>
	);
}
